import { extractSectorName } from '../../../utils/functions'

export class SmCartWrapper {
    constructor(smRenderer, cartCapacity) {
        this.smRenderer = smRenderer
        this.cartCapacity = cartCapacity
    }

    updateGa(updatedGaItem) {
        const cart = this.getCart()
        this.smRenderer.clearCart()
        this.smRenderer.addSeatsToCart(cart.seats)

        var itemFoundInCart = false
        cart.ga.forEach((cartItem) => {
            if(cartItem.key === updatedGaItem.name) {
                cartItem.count = updatedGaItem.count
                itemFoundInCart = true
            }
            this.smRenderer.addGaToCart(cartItem)
        })

        if(!(itemFoundInCart)) {
            this.smRenderer.addGaToCart({
                ...updatedGaItem,
                key: updatedGaItem.name,
            })
        }
    }

    exportCart() {
        this.trimSeatsIfCartFull()
        return this.toArray()
    }

    trimSeatsIfCartFull() {
        if (this.cartCapacity < 0) {
            return
        }
        if(this.getItemsCount() > this.cartCapacity) {
            const cart = this.getCart()
            const seats = cart.seats.slice(0, this.cartCapacity - this.getGaCount())

            this.smRenderer.clearCart()
            this.smRenderer.addSeatsToCart(seats)
            cart.ga.forEach((gaItem) => this.smRenderer.addGaToCart(gaItem))
        }
    }

    toArray() {
        const cart = this.getCart()
        var selectedTickets = []

        cart.seats.forEach((seat) => {
            selectedTickets.push({
                name: extractSectorName(seat.key),
                key: seat.key,
                price: seat.price.toFixed(2),
                type: 'seat',
                count: 1,
                bookRandomly: false
            })
        })

        cart.ga.forEach((gaSeat) => {
            selectedTickets.push({
                name: extractSectorName(gaSeat.key),
                key: gaSeat.key,
                price: gaSeat.price.toFixed(2),
                type: 'ga',
                count: gaSeat.count,
                bookRandomly: true
            })
        })

        return selectedTickets
    }

    getAvailableForOrder() {
        const available = this.cartCapacity - this.getItemsCount()
        return available
    }
    
    getItemsCount() {
        return this.getSeatsCount() + this.getGaCount()
    }

    getSeatsCount() {
        const cart = this.getCart()
        return cart.seats.length
    }

    getGaCount(name) {
        const cart = this.getCart()
        var gaCount = 0
        cart.ga.forEach((cartItem) => {
            if(name === undefined || name === cartItem.key) {
                gaCount += cartItem.count
            }
        })
        return gaCount
    }

    getCart() {
        return this.smRenderer.getCart()
    }
}

